const tooltips = {
  generic: {
    flag: `Orange - Restock now\nYellow - Restock soon\nRed - Out of stock\nGreen - Well stocked\nTeal - New product`,
    alertDate: 'The Date the flag alert was created',
    status: 'SKU Restock Importance Filter',
    sku: 'Your unique product identifier',
    productName: 'The name of the product',
    asin: "Amazon's product identifier",
    type: 'Product type of Kit or Part (of kit)',
    imageUrl: 'Show Image',
    tag: 'Your custom product tags',
    prepGuide: "Amazon's product prep instructions",
    skuNotes: 'Your custom product notes',
    prepNotes: 'Your custom product prep notes',
    supplier: 'Common business name of your supplier',
    supplierSku: "The supplier's unique product identifier",
    supplierCost: 'The current supplier cost of the product',
    supplierRebate:
      'Per unit value of any discounts, rebates, or allowances you receive from the supplier. This value is used in your estimated margin calculation. ',
    inboundShippingCost:
      'Your cost to ship this product from your supplier to its destination',
    reshippingCost:
      'Your cost to ship this product from your warehouse to Amazon',
    repackagingMaterialCost:
      'The cost of materials required to repackage this product before sending it to Amazon',
    repackingLaborCost:
      'The cost of labor required to repackage this product before sending it to Amazon',
    restockModel: 'The method by which you typically replenish this product',
    fnsku: "Amazon's identifier to FBA product",
    upc: 'Universal Product Cost - UPC is a barcode used for tracking products',
    ean: 'European Article Number - EAN is a barcode used for tracking products',
    avg7DPrice:
      'The average price the product has sold for over the past 7 days',
    listPrice: 'The current list price of the product',
    soldBy: 'The Amazon icon displays when Amazon is a seller of this product',
    newBuyBox:
      'The most recent buy box price for this product in new condition',
    fba: '# FBA sellers offering the product',
    lowestFba: 'The lowest list price by any FBA sellers',
    nonFba: '# non-FBA sellers offering the product',
    lowestNonFba: 'The lowest list price by any FBA seller',
    packageWeight: 'The weight of the product package in pounds',
    dimensionalWeight:
      ' The dimensional weight, calculated by Amazon, of the product',
    casePackQuantity:
      'The number of units that this product must be ordered in from as supplier',
    hazmat: 'Products that require special hading and storage by Amazon',
    oversized:
      'Denotes products that must be delivered using special delivery options due to their size, weight, special handing requirements, or other restrictions',
    s2d: '2D',
    s7d: '7D',
    s30d: '30D',
    s60d: '60D',
    s90d: '90D',
    s180d: '180D',
    em: 'The estimated margin expected from your next sale, based on your Inventory Optimizer price and cost settings',
    emPercent: 'The estimated margin expected as a percentage',
    markupPercent: 'The estimated markup expressed as a percentage',
    category: 'The Amazon product category of the product',
    rank: "The product's rank within is Amazon product category",
    referralFee:
      'The fee charged by Amazon every time you sell 1 unit of this product based on your current list price',
    fbaFee:
      'The additional fees charged by Amazon to pick, pack, and ship a customer order',
    qoh: 'The total quantity on hand across the Amazon fulfillment center network',
    inbound:
      'The number of unit included in all shipments on the way to an Amazon fulfillment center',
    sum: 'Your total Amazon QoH plus inbound units',
    inbWorking:
      "The number of units included in pending shipments with the 'Working' status",
    inbShipped:
      'The number of units included in shipments that are en route to an Amazon fulfillment center',
    inbReceiving:
      'The number of units included in shipments that are being received by an Amazon fulfillment center',
    inboundTotal:
      'The total number of units included in all inbound shipments',
    targetDays:
      'The maximum number of days of inventory coverage you would like to keep at Amazon',
    remaining:
      'The number of days of inventory coverage remaining at Amazon given your current Average Daily Sales Rate',
    demand:
      'The forecasted sales per day for this product given our current Average Daily Sales Rate',
    outOfStockPercent:
      'The percentage of time this product has been out stock',
    reserved:
      'Number of units Amazon has set aside for customer orders, FC transfer, or FC processing',
    unfulfillable: "Amazon's reported # of damaged or returned units",
    pending: 'Number of units included in pending Amazon customer orders',
    localQty: 'Inventory you have outside of Amazon FBA and FBM',
    maximumShipmentQty:
      'ASIN-level quantity limit for products stored in Amazon fulfillment centers',
    suggShip:
      'The number of units Inventory Optimizer suggests shipping from your warehouse inventory to Amazon',
    suggReorder:
      'The number of units Inventory Optimizer suggests reordering from your supplier',
    onOrder: 'The number of units on order from your supplier',
    restockNeeded:
      'Ideal Max Quantity on Hand minus Amazon QoH',
    orderQty: 'The number of units entered for an in progress purchase order',
    outOfStockPercentage: '% of time out of stock over target days',
    doNotRestock: 'Hides from your restock recommendations',
    forecastRecommendedQty: 'Recommended qty based on forecast models only',
    recommendedSupplierQty: 'The number of units Inventory Optimizer suggests reordering from your supplier',
    recommendedWarehouseQty: 'The number of units Inventory Optimizer suggests shipping from your warehouse inventory to Amazon.',
    casePackForecastRecommendedQty: 'Recommended qty based on forecast models only',
    casePackSuggReorder: 'The number of units Inventory Optimizer suggests reordering from your supplier.',
    casePackSuggShip: 'The number of units Inventory Optimizer suggests shipping from your warehouse inventory to Amazon.',
    forecastedQty: 'Recommended qty based on forecast models only',
    recommendedQty: 'The number of units Inventory Optimizer suggests shipping from your warehouse inventory to Amazon.',
    itemVolume: 'Storage volume per unit',
    storageVolume: 'Total usage for this product in fulfillment centers minus inventory pending removal',
    storageType: 'FBA storage type',
    historicalDaysOfSupply: 'Ratio of avg. on hand sellable units to avg. daily shipped units by parent ASIN',
    lostSale2d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale7d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale14d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale30d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale60d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale90d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale180d: 'Estimated number of units that could have been sold during stockout periods.',
    lostSale365d: 'Estimated number of units that could have been sold during stockout periods.',
    // --- Keys added from ASC so other companies (QBFS, QBO, CSV, etc.) inherit them ---
    inboundFcTransfer: 'Total units currently being transferred between fulfillment centers',
    onHandFbm: 'Available FBM inventory synced from AMZ',
    inboundAwd: 'The number of units currently in transit to AWD synced from AMZ',
    inboundWorking: 'Units in inbound shipments currently being prepared or processed',
    awdInventoryQty: 'The total available inventory stored in AWD',
    totalSurcharge: 'Estimated storage surcharge for inventory over 180 days',
    inboundShipped: 'Units currently shipped and in transit to Amazon.',
    inboundReceiving: 'Units currently being received by Amazon fulfillment centers',
    createdAt: 'The date the item was created',
    inboundWorkingAwd: 'Units in AWD shipments being created',
    inboundShippedAwd: 'Units shipped to AWD',
    inboundReceivingAwd: 'Units being received at AWD',
    inboundTotalAwd: 'Total units in all AWD inbound shipments',
  },
  ASC: {
    sku: 'The name used to identify products in the inventory',
    status:'Restock monitoring status for the item',
    inboundFcTransfer: 'Total units currently being transferred between fulfillment centers',
    onHandFbm: 'Available FBM inventory synced from AMZ',
    qoh: 'Available FBA inventory synced from AMZ',
    inbound: 'The number of units currently in transit synced from AMZ',
    inboundAwd: 'The number of units currently in transit to AWD synced from AMZ',
    unfulfillable:'Units synced from Amazon that are marked as unfulfillable',
    inboundWorking:'Units in inbound shipments currently being prepared or processed',
    hazmat: 'Indicates whether the item requires special handling',
    oversized: 'Indicates whether the item is classified as oversized by Amazon',
    ean: 'European Article Number for this item',
    rank: 'Amazon sales rank within its product category',
    prepGuide: 'Amazon-required preparation instructions for the item',
    prepNotes: 'Internal notes related to item preparation',
    supplier: 'Common business name of your supplier',
    supplierRebate: 'Per-unit supplier discount used in margin calculations',
    inboundShippingCost: 'Cost to ship this item from the supplier to AMZ',
    reshippingCost: 'Cost to ship this item from your warehouse to AMZ',
    repackagingMaterialCost: 'Cost of materials used to repackage this item',
    dimensionalWeight: 'Dimensional weight calculated by AMZ',
    awdInventoryQty: 'The total available inventory stored in AWD',
    doNotRestock: 'Excludes this item from restock recommendations',
    totalSurcharge: 'Estimated storage surcharge for inventory over 180 days',
    fnsku: 'Amazon fulfillment identifier used for FBA inventory',
    asin: 'Amazon Standard identification number',
    imageUrl: 'Item image',
    tags:'User-defined labels for organizing and filtering items',
    type: 'Indicates whether the item is a kit or component',
    skuNotes: 'Internal notes related to the SKU',
    upc: 'Universal Product Code for this item',
    fba: 'Number of FBA sellers offering this product',
    nonFba: 'Number of non-FBA sellers offering this product',
    casePackQuantity:'Number of items must be ordered together from the supplier',
    s2d: 'Sales in the last 48 hours',
    s7d: 'Sales in the last 7 days',
    s14d: 'Sales in the last 14 days',
    s30d: 'Sales in the last 30 days',
    s60d: 'Sales in the last 60 days',
    s90d: 'Sales in the last 90 days',
    s180d: 'Sales in the last 180 days',
    average7DayPrice: 'Average Amazon selling price over the last 7 days',
    sum: 'Total units including On Hand FBA, FC Transfers, and Inbound inventory',
    inboundShipped: 'Units currently shipped and in transit to Amazon.',
    inboundReceiving: 'Units currently being received by Amazon fulfillment centers',
    category: 'The category this item is classified as',
    boxLength: 'Length of the box used to ship this item to Amazon',
    boxWidth: 'Width of the box used to ship this item to Amazon',
    boxHeight: 'Height of the box used to ship this item to Amazon',
    boxWeight: 'Weight of the box used to ship this item to Amazon',
    estimatedExcessUnits: 'Estimated excess quantity of this item from Amazon',
    estimatedAgedInventorySurcharges: 'Show surcharges based on inventory age. ASINs older than 180 days incur a surcharge based on storage volume',
    packageWeight: 'Weight of the item used for calculating shipping costs',
    repackingLaborCost: 'Cost of labor used to repackage item',
    createdAt: 'The date the item was created',
    inboundWorkingAwd: 'Units in AWD shipments being created',
    inboundShippedAwd: 'Units shipped to AWD',
    inboundReceivingAwd: 'Units being received at AWD',
    inboundTotalAwd: 'Total units in all AWD inbound shipments',
    lowestFba: 'Lowest price offered by FBA sellers',
    lowestNonFba: 'Lowest price offered by non-FBA sellers',
  },
  QBFS:{
    lotNumber: 'The lot or batch number used to track inventory for this item'
  }
};

export function getFieldGroupTip(field: string, companyType?: string): string {
  if (companyType && tooltips[companyType]) {
    const tip = tooltips[companyType][field];
    if (tip) return tip;
  }
  return tooltips.generic[field] || '';
}

/**
 * Maps RestockSuggestionItemField names to their rich tooltip config key
 * in RICH_HEADER_TOOLTIP_CONFIGS.
 */
export const FIELD_GROUP_RICH_TOOLTIP_KEYS: Record<string, string> = {
  localQty: 'warehouseQtySupply',
  estimatedMargin: 'estimatedMargin',
  estimatedMarginPercentage: 'estimatedMarginPercentage',
  estimatedMarkupPercentage: 'estimatedMarkupPercentage',
  outOfStockPercentage: 'outOfStockPercentage',
  suggShip: 'suggShip',
  suggReorder: 'suggReorder',
  restockNeeded: 'restockNeeded',
};

export function getFieldGroupRichTooltipKey(field: string): string {
  return FIELD_GROUP_RICH_TOOLTIP_KEYS[field] ?? '';
}

export enum ItemStatus {
  ACTIVE = 'ACTIVE',
  WATCH = 'WATCH',
  IGNORE = 'IGNORE',
  INACTIVE = 'INACTIVE',
}

export enum FlagName {
  ORANGE = 'Restock now',
  YELLOW = 'Restock soon',
  RED = 'Out of Stock',
  TEAL = 'New',
  GREEN = 'Well stocked'
}

export enum ConditionOperator {
  AND = 'AND',
  OR = 'OR',
}

export interface ShipmentDropDown {
  text: string;
  value: string;
}
